"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.L1TradeTerminal = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const Tags_1 = require("../Tags");
const Size_1 = require("../render/Size");
const LogHelper_1 = require("../../LogHelper");
const SelectCard_1 = require("../../inputs/SelectCard");
class L1TradeTerminal extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.L1_TRADE_TERMINAL,
            tags: [Tags_1.Tags.SPACE],
            cost: 25,
            metadata: {
                cardNumber: 'P78',
                description: 'Add a resource to 3 different cards that already have resources.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.effect('When you trade, first increase that Colony Tile track 2 steps.', (eb) => {
                        eb.trade().startEffect.text('+2', Size_1.Size.LARGE);
                    });
                    b.br;
                    b.diverseResource(3).digit.nbsp().asterix();
                }),
                victoryPoints: 2,
            },
        });
    }
    play(player) {
        player.colonyTradeOffset += 2;
        const resourceCards = player.getResourceCards().filter((c) => c.resourceCount !== undefined && c.resourceCount > 0);
        const robotCards = player.getSelfReplicatingRobotsTargetCards();
        const targets = resourceCards.concat(robotCards.map((c) => c.card));
        const count = Math.min(targets.length, 3);
        if (targets.length === 0)
            return undefined;
        return new SelectCard_1.SelectCard(`Select up to ${count} cards to add 1 resource to each`, 'Add resources', targets, (foundCards) => {
            foundCards.forEach((card) => {
                const robotCard = robotCards.find((c) => c.card.name === card.name);
                if (robotCard) {
                    robotCard.resourceCount++;
                    LogHelper_1.LogHelper.logAddResource(player, robotCard.card);
                }
                else {
                    player.addResourceTo(card, { log: true });
                }
            });
            return undefined;
        }, { min: 1, max: count });
    }
    getVictoryPoints() {
        return 2;
    }
    onDiscard(player) {
        player.colonyTradeOffset -= 2;
    }
}
exports.L1TradeTerminal = L1TradeTerminal;
//# sourceMappingURL=L1TradeTerminal.js.map